(function () {
document.addEventListener("DOMContentLoaded", () => {
  var slider = new KeenSlider(
    ".article__reviews-slider",
    {
      slides: {
        perView: 1,
      },
      loop: false,
      breakpoints: {
        "(min-width: 750px)": {
          slides: {
            perView: 3,
          },
        },
      },
    },
    [navigation]
  );
});

function navigation(slider) {
  let wrapper, dots, arrowLeft, arrowRight, navigationWrapper;

  function markup(remove) {
    wrapperMarkup(remove);
    dotMarkup(remove);
    arrowMarkup(remove);
  }

  function removeElement(elment) {
    elment.parentNode.removeChild(elment);
  }

  function createDiv(className) {
    var div = document.createElement("div");
    var classNames = className.split(" ");
    classNames.forEach((name) => div.classList.add(name));
    return div;
  }

  function createButton(className, ariaLabel) {
    var btn = document.createElement("button");
    btn.setAttribute("type", "button");
    if (ariaLabel) btn.setAttribute("aria-label", ariaLabel);
    var classNames = className.split(" ");
    classNames.forEach((name) => btn.classList.add(name));
    return btn;
  }

  function bindArrow(button, direction) {
    if (!button || button.dataset.reviewsBound === "true") return;
    button.addEventListener("click", () => {
      if (direction === "prev") slider.prev();
      else slider.next();
    });
    button.dataset.reviewsBound = "true";
  }

  function arrowMarkup(remove) {
    if (remove) {
      if (arrowLeft && !arrowLeft.hasAttribute("data-reviews-prev")) removeElement(arrowLeft);
      if (arrowRight && !arrowRight.hasAttribute("data-reviews-next")) removeElement(arrowRight);
      return;
    }

    var root = slider.container.closest(".article__reviews") || document;
    arrowLeft = root.querySelector("[data-reviews-prev]");
    arrowRight = root.querySelector("[data-reviews-next]");

    if (!arrowLeft) {
      arrowLeft = createButton("arrow arrow--left", "Previous slide");
      arrowLeft.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" aria-hidden="true" focusable="false"><path stroke-linecap="round" stroke-linejoin="round" d="m8.25 4.5 7.5 7.5-7.5 7.5" /></svg>`;
    }
    if (!arrowRight) {
      arrowRight = createButton("arrow arrow--right", "Next slide");
      arrowRight.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" aria-hidden="true" focusable="false"><path stroke-linecap="round" stroke-linejoin="round" d="m8.25 4.5 7.5 7.5-7.5 7.5" /></svg>`;
    }

    bindArrow(arrowLeft, "prev");
    bindArrow(arrowRight, "next");

    wrapper.insertBefore(arrowLeft, slider.container);
    navigationWrapper.appendChild(arrowRight);
  }

  function wrapperMarkup(remove) {
    if (remove) {
      var parent = wrapper.parentNode;
      while (wrapper.firstChild)
        parent.insertBefore(wrapper.firstChild, wrapper);
      removeElement(wrapper);
      return;
    }
    wrapper = createDiv("navigation-wrapper");
    slider.container.parentNode.appendChild(wrapper);
    wrapper.appendChild(slider.container);

    navigationWrapper = createDiv("slider__navigation-wrapper");
    wrapper.appendChild(navigationWrapper);
  }

  function dotMarkup(remove) {
    if (remove) {
      removeElement(dots);
      return;
    }
    dots = createDiv("dots");
    slider.track.details.slides.forEach((_e, idx) => {
      var dot = createDiv("dot");
      dot.addEventListener("click", () => slider.moveToIdx(idx));
      dots.appendChild(dot);
    });
    navigationWrapper.appendChild(dots);
  }

  function updateClasses() {
    var slide = slider.track.details.rel;
    var atStart = slide === 0;
    var atEnd = slide === slider.track.details.slides.length - 1;
    arrowLeft.classList.toggle("arrow--disabled", atStart);
    arrowLeft.setAttribute("aria-disabled", atStart ? "true" : "false");
    arrowRight.classList.toggle("arrow--disabled", atEnd);
    arrowRight.setAttribute("aria-disabled", atEnd ? "true" : "false");
    Array.from(dots.children).forEach(function (dot, idx) {
      idx === slide
        ? dot.classList.add("dot--active")
        : dot.classList.remove("dot--active");
    });
  }

  slider.on("created", () => {
    markup();
    updateClasses();
  });

  slider.on("optionsChanged", () => {
    markup(true);
    markup();
    updateClasses();
  });

  slider.on("slideChanged", () => {
    updateClasses();
  });

  slider.on("destroyed", () => {
    markup(true);
  });
}
})();
